export default (() => {
  const body = $('body')
  const html = $('html')
  const overlay = $('#overlay-menu')
  const overlayPrimary = $('.overlay-primary-container');
  const overlaySearch= $('.overlay-search');
  const searchButton= $('.search-toggle');
  const overlaySecondary = $('.overlay-secondary-container');
  const logoInvert = $('.logo-invert');
  const logo = $('.logo');
  const header = $('.main-header')
  const preHeader = $('.pre-header')
  const hamburger = $('#overlay-menu-toggle')


  let activeSearch = 0;
  let activeOverlay = 0;



  searchButton.on('click', function () {
    if(activeOverlay == 1) {
        return;
    }

        overlaySearch.toggleClass('active')
        html.toggleClass('locked');
        body.toggleClass('locked');
        preHeader.toggleClass('active');
        header.toggleClass('active')
        logoInvert.toggleClass('active');
        logo.toggleClass('active');


        if(activeSearch == 0) {
            activeSearch = 1
        } else {
            activeSearch = 0
        }
  })

    $(window).on('scroll',function( e ){
        if ($(window).outerWidth() < 1024) return; 
        if( $(this).scrollTop() > 120){
            if(activeSearch == 1) {
                return;
            }
                hamburger.removeClass('is-active')
                overlayPrimary.removeClass('active');
                html.removeClass('locked');
                body.removeClass('locked');
                preHeader.removeClass('active');
                header.removeClass('active')
                overlaySecondary.removeClass('active');
                logoInvert.removeClass('active');
                logo.removeClass('active');
                overlay.removeClass('active');
    }

    });

  hamburger.on('click', function() {
        if(activeSearch == 1) {
            return;
        }      
        $(this).toggleClass('is-active');
        overlayPrimary.toggleClass('active');
        html.toggleClass('locked');
        body.toggleClass('locked');
        preHeader.toggleClass('active');
        header.toggleClass('active')
        overlaySecondary.toggleClass('active');
        logoInvert.toggleClass('active');
        logo.toggleClass('active');
        overlay.toggleClass('active');

    
        if(activeOverlay == 0) {
            activeOverlay = 1
        } else {
            activeOverlay = 0
        }
  });


let subMenu = $('.overlay-primary.mobile .menu-item-has-children');

subMenu.on('click', function (e) {
    e.preventDefault()

    $(this).toggleClass('active')
}).children('.sub-menu').on('click', function(e) { // catch all children click
    e.stopPropagation();
});

})($)


// WEBPACK FOOTER //
// ./scripts/layout/overlay-menu.js